export default __webpack_public_path__ + "static/media/grafema_SET_22.37e10316.jpg";